var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 7.20001C5.6001 6.77566 5.76867 6.36869 6.06873 6.06864C6.36878 5.76858 6.77575 5.60001 7.2001 5.60001H12.0001C12.4244 5.60001 12.8314 5.76858 13.1315 6.06864C13.4315 6.36869 13.6001 6.77566 13.6001 7.20001V12C13.6001 12.4244 13.4315 12.8313 13.1315 13.1314C12.8314 13.4314 12.4244 13.6 12.0001 13.6H7.2001C6.77575 13.6 6.36878 13.4314 6.06873 13.1314C5.76867 12.8313 5.6001 12.4244 5.6001 12V7.20001Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 2.39999C3.57556 2.39999 3.16859 2.56856 2.86853 2.86862C2.56847 3.16868 2.3999 3.57565 2.3999 3.99999V8.79999C2.3999 9.22434 2.56847 9.63131 2.86853 9.93136C3.16859 10.2314 3.57556 10.4 3.9999 10.4V3.99999H10.3999C10.3999 3.57565 10.2313 3.16868 9.93127 2.86862C9.63121 2.56856 9.22425 2.39999 8.7999 2.39999H3.9999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.3ce4839ff1f6d76ab71e616085c9b7e0.svg";
export { ForwardRef as ReactComponent };